// extracted by mini-css-extract-plugin
export default {"main":"style_main__YaLtT","catalogContainer":"style_catalogContainer__u+QrB"};